module.exports = __webpack_public_path__ + "img/instruction_fullorder_3d.4ae49a7e.png";